module.exports = __webpack_public_path__ + "static/media/bbpos_swipe_insert.e09cc054.png";